module.exports = __webpack_public_path__ + "img/icon_5_15.9e56ac15.png";